import { Component, OnInit } from '@angular/core';
import { ContextService } from '@core/services/core/context.service';
import { DeregisterHelperService } from '@modules/deregister/services/deregister-helper.service';

@Component({
  selector: 'app-deregister-request',
  templateUrl: './deregister-request.component.html',
  styleUrls: ['./deregister-request.component.scss']
})
export class DeregisterRequestComponent implements OnInit {

  constructor(
    public ctx: ContextService,
    private deregisterHelperService: DeregisterHelperService
  ) { }

  ngOnInit() {
  }

  onContinue() {
    this.deregisterHelperService.sendDeregisterRequest();
  }

}
